import * as React from "react";
import { cn } from "../../../../../utils/cn";
import { useTranslation } from "react-i18next";

import "./input-filter.css";

type InputType = "text" | "date";

type InputFilterProps = Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  "onChange" | "value" | "type"
> & {
  value: string;
  onChange: (React.Dispatch<React.SetStateAction<string>>);
  delay?: number;
  className?: string;
  type?: InputType;
};

export const InputFilter = ({
  value,
  onChange,
  placeholder,
  className = "",
  delay = 800,
  type="text",
  ...inputProps
}: InputFilterProps) => {
  const { t } = useTranslation();
  const [inputValue, setInputValue] = React.useState(value);

  React.useEffect(() => {
    setInputValue(value);
  }, [value]);

  React.useEffect(() => {
    if (inputValue === value) {
      return;
    }

    const timeoutId = window.setTimeout(() => {
      onChange(inputValue);
    }, delay);

    return () => clearTimeout(timeoutId);
  }, [inputValue, value, delay, onChange]);

  return (
    <input
      type={type}
      className={cn("border-1 input-filter", className)}
      value={inputValue}
      onChange={(e) => setInputValue(e.target.value)}
      placeholder={t(`common:fields.${placeholder}`)}
      maxLength={100}
    />
  );
};
